import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import './whyDaroma.scss'

const WhyDaroma = () => {
    const { t } = useTranslation();
    const lineRefs = useRef([]);
    
        useEffect(() => {
            const observerOptions = {
                threshold: 0.2,
                rootMargin: '0px 0px 0px 0px'
            };
    
            const lineObservers = lineRefs.current.map((lineRef) => {
                if (!lineRef) return null;
    
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            entry.target.classList.add('content__title-line--visible');
                            observer.unobserve(entry.target);
                        }
                    });
                }, observerOptions);
    
                observer.observe(lineRef);
                return observer;
            });
    
            return () => {
                lineObservers.forEach(obs => obs?.disconnect());
            };
        }, []);
    
        return (
            <div className="whyDaroma-info">
                <div className='whyDaroma-info__content'>
                    <div className='whyDaroma-info__section'>
                        <h2 className='content__title-backgroundWhite'>{t("home.why.title")}</h2>
                        <div ref={el => lineRefs.current[0] = el} className="content__title-line" />
                        <h3 className='content__subtitle-backgroundWhite'>{t("home.why.subtitle")}</h3>
                        <p className='content__text-title-backgroundWhite'>
                            {t("home.why.lead")}
                        </p>
                    </div>
                    <div className='whyDaroma-info__section'>
                        <p className='content__text-paragrah-backgroundWhite'>
                            {t("home.why.p1")}
                        </p>
                        <p className='content__text-paragrah-backgroundWhite'>
                            {t("home.why.p2")}
                        </p>
                    </div>
                </div>
            </div>
        )
    }

export default WhyDaroma
